export default "__VITE_ASSET__4jTduluy__"